import React from 'react'
import {
  TextInput,
  required,
  SelectInput,
  ImageInput,
  ImageField,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles, Button } from '@material-ui/core'

import { ResourceSelectorEdit, Tooltip } from 'components'

import { useDispatch } from 'react-redux'

import * as actions from 'customReducers/popupReducer/actions'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
  contentPaddingBottom: {
    marginBottom: 12,
  },
})

export const EditForm = (props: any) => {
  const classes = useStyles()
  const { setFormData, formData, toolbar, aside, ...rest } = props
  const dispatch = useDispatch()

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={2}
      className={classes.gridContainer}
    >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper className={classes.paperContainer}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h5" color="textSecondary" gutterBottom>
              Editar Popup
            </Typography>
            <hr />
          </Grid>

          <Grid
            container
            spacing={2}
            className={classes.gridContainer}
            direction="column"
          >
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'popups.title'}>
                <TextInput
                  fullWidth
                  label="Título"
                  source="title"
                  validate={[required('Obrigatório')]}
                />
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'popups.description'}>
                <TextInput
                  fullWidth
                  label="Descrição"
                  source="description"
                  validate={[required('Obrigatório')]}
                />
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'popups.summary'}>
                <TextInput
                  fullWidth
                  label="Link"
                  source="summary"
                  validate={[required('Obrigatório')]}
                />
              </Tooltip>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'popups.type'}>
                <SelectInput
                  fullWidth
                  label="Tipo"
                  source="type"
                  choices={[
                    { id: 'alwaysShow', name: 'Exibir Sempre' },
                    { id: 'none', name: 'Exibir uma vez' },
                  ]}
                  validate={[required('Obrigatório')]}
                  resettable
                  externalLoading={false}
                />
              </Tooltip>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'popups.status'}>
                <SelectInput
                  fullWidth
                  label="Status"
                  source="status"
                  choices={[
                    { id: 'ativo', name: 'Ativo' },
                    { id: 'inativo', name: 'Inativo' },
                  ]}
                  validate={[required('Obrigatório')]}
                  resettable
                  externalLoading={false}
                />
              </Tooltip>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <hr />
            </Grid>
            <Tooltip title={'popups.contents.images'}>
              <ResourceSelectorEdit
                fullWidth
                label="Imagem principal"
                source="contents.images[0].id"
                resource="cms/content/images"
                optionValue="id"
                validate={[required('Obrigatório')]}
                choicesFilter={{
                  target: 'type',
                  filter: 'popup',
                }}
                selectedValue={
                  formData?.contents?.images?.length >= 1
                    ? formData.contents.images[0].id
                    : null
                }
              />
            </Tooltip>

            <Tooltip title={'popups.images.main'}>
              <ResourceSelectorEdit
                fullWidth
                label="Imagem secundária"
                source="contents.images[1].id"
                resource="cms/content/images"
                optionValue="id"
                validate={[required('Obrigatório')]}
                choicesFilter={{
                  target: 'type',
                  filter: 'popup',
                }}
                selectedValue={
                  formData?.contents?.images?.length >= 2
                    ? formData.contents.images[1].id
                    : null
                }
              />
            </Tooltip>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <hr />
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
              >{`Tema do popup: `}</Typography>
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
              >
                {`As cores precisam ser cadastradas previamente. Insira o código Hexadecimal da cor já cadastrada para vincular, ou clique em [Criar Novo Tema].`}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
              <ResourceSelectorEdit
                fullWidth
                label="Cor do botão"
                source={`contents.stylesheets[3].id`}
                resource="cms/content/stylesheets"
                optionValue="id"
                choicesFilter={{
                  target: 'type',
                  filter: 'btn',
                }}
                selectedValue={
                  formData?.contents?.stylesheets?.length > 3 &&
                  formData?.contents?.stylesheets[3]?.id
                    ? formData.contents.stylesheets[3].id
                    : null
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
              <ResourceSelectorEdit
                fullWidth
                label="Cor do texto do botão"
                source={`contents.stylesheets[2].id`}
                resource="cms/content/stylesheets"
                optionValue="id"
                choicesFilter={{
                  target: 'type',
                  filter: 'text',
                }}
                selectedValue={
                  formData?.contents?.stylesheets?.length > 2 &&
                  formData?.contents?.stylesheets[2]?.id
                    ? formData.contents.stylesheets[2].id
                    : null
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
              <ResourceSelectorEdit
                fullWidth
                label="Cor do hover do botão"
                source={`contents.stylesheets[1].id`}
                resource="cms/content/stylesheets"
                optionValue="id"
                choicesFilter={{
                  target: 'type',
                  filter: 'hover',
                }}
                selectedValue={
                  formData?.contents?.stylesheets?.length > 1 &&
                  formData?.contents?.stylesheets[1]?.id
                    ? formData.contents.stylesheets[1].id
                    : null
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
              <ResourceSelectorEdit
                fullWidth
                label="Cor do fundo"
                source={`contents.stylesheets[0].id`}
                resource="cms/content/stylesheets"
                optionValue="id"
                choicesFilter={{
                  target: 'type',
                  filter: 'background',
                }}
                selectedValue={
                  formData?.contents?.stylesheets?.length > 0 &&
                  formData?.contents?.stylesheets[0]?.id
                    ? formData.contents.stylesheets[0].id
                    : null
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => dispatch(actions.stylesheetsDialog())}
                className={classes.contentPaddingBottom}
              >
                Criar novo Tema
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
